import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import MainButton from '../common/util/input/MainButton'
import { get } from '../helpers/Api'
import { getBoostAction } from '../helpers/WaxApi'
import SelectionField from '../searchitems/searchfilters/SelectionField'
import Popup from './Popup'
import { useSharedState } from '../waxplorer/Waxplorer'

function TagsPopup(props) {
    const closeCallBack = props.closeCallBack
    const collectionName = props.collectionName

    const [state] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const callBack = props['callBack']

    const { t } = useTranslation('common')
    const appliedTags = props.tags

    const [selectedTags, setSelectedTags] = useState([])

    const [tags, setTags] = useState([])

    const suggest = props.suggest

    const cancel = () => {
        closeCallBack()
        callBack({ addedTags: false, error: null })
    }

    const selectTag = (tag) => {
        const newTags = []
        if (selectedTags.includes(tag.value)) {
            for (let selectedTag of selectedTags) {
                if (selectedTag !== tag.value) {
                    newTags.push(selectedTag)
                }
            }
        } else {
            for (let selectedTag of selectedTags) {
                newTags.push(selectedTag)
            }
            newTags.push(tag.value)
        }
        setSelectedTags(newTags)
    }

    const parseTags = (res) => {
        setTags(res)
    }

    const getMissingTags = async (collectionName) => {
        get('missing-tags/' + collectionName, 'wax-api').then(parseTags)
    }

    useEffect(() => {
        getMissingTags(collectionName)
    }, [collectionName])

    let dropDownOptions = []
    tags.sort((a, b) => a.tagId - b.tagId).map((tag) => {
        dropDownOptions.push({
            value: tag.tagId,
            label:
                t(`collection_tags.${tag.tagId}`) !==
                `collection_tags.${tag.tagId}`
                    ? t(`collection_tags.${tag.tagId}`)
                    : tag.tagName[0].toUpperCase() + tag.tagName.substring(1),
        })
    })

    const save = async () => {
        const actions = [getBoostAction(activeUser)]
        closeCallBack()

        if (suggest) {
            for (let tagId of selectedTags) {
                actions.push({
                    account: 'clltncattool',
                    name: 'suggesttag',
                    authorization: [
                        {
                            actor: userName,
                            permission: activeUser.requestPermission
                                ? activeUser.requestPermission
                                : 'active',
                        },
                    ],
                    data: {
                        collection_name: collectionName,
                        tag_id: tagId,
                    },
                })
            }
        } else {
            for (let tagId of selectedTags) {
                actions.push({
                    account: 'clltncattool',
                    name: 'settag',
                    authorization: [
                        {
                            actor: userName,
                            permission: activeUser.requestPermission
                                ? activeUser.requestPermission
                                : 'active',
                        },
                    ],
                    data: {
                        collection_name: collectionName,
                        tag_id: tagId,
                        authorized_tagger: userName,
                    },
                })
            }
        }

        try {
            const result = await activeUser.session.transact(
                {
                    actions: actions,
                },
                {
                    expireSeconds: 300,
                    blocksBehind: 0,
                },
            )
            const addedTags = []

            for (let selectedTag of selectedTags) {
                for (let option of dropDownOptions) {
                    if (option.value === selectedTag) {
                        addedTags.push({
                            tagId: option.value,
                            tagName: option.label,
                        })
                    }
                }
            }

            callBack({
                addedTags: addedTags,
                error: null,
            })
        } catch (e) {
            callBack({ addedTags: false, error: e.message })
            console.error(e)
        }
    }

    return (
        <Popup
            cancel={cancel}
            title={
                suggest
                    ? `Suggest a Tag for the ${collectionName} collection`
                    : `Select your desired category for the ${collectionName} collection`
            }
            className="h-auto"
        >
            <div className={cn('block h-full')}>
                <div className={'w-full mx-auto'}>
                    <SelectionField
                        multiSelect
                        size="lg"
                        center={true}
                        options={dropDownOptions}
                        onChange={selectTag}
                        values={selectedTags}
                        lockedValues={
                            appliedTags && appliedTags.map((tag) => tag.tagId)
                        }
                        placeholder={t('search.schema')}
                        id="DropdownField3"
                    />
                </div>
                <div className={'flex justify-center mt-4 gap-2'}>
                    <MainButton onClick={cancel} className="bg-red-500">
                        {t('asset.cancel')}
                    </MainButton>
                    <MainButton
                        onClick={save}
                        disabled={selectedTags.length === 0 ? 'disabled' : ''}
                    >
                        Save
                    </MainButton>
                </div>
            </div>
        </Popup>
    )
}

export default TagsPopup
